<template lang="pug">
v-layout(align-start)
  v-flex
    v-data-table.elevation-1(:headers='headers' item-key='proveedores' :items='proveedores' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
      template(v-slot:top)
        v-toolbar(flat color='primary' dark)
          v-toolbar-title.justify-center Proveedores
          v-divider.mx-4(inset vertical)
          v-spacer
          v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
          v-spacer
          v-btn.mx-2(v-if='validarCrear()' fab dark small color='success' @click='dialog = true, oth = false' )
            v-icon(dark) mdi-plus
          ProveedorM(:dialog='dialog' :editedIndex='editedIndex' @close='close' :edicion='edicion' :read='read' :mostrar='mostrar' :FormPadre='editedItem' @save='listarProveedor' @edited='listarProveedor', :other='oth')
      template(v-slot:item.action='{ item }')
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon.mr-2(color='primary_2' @click='editItem( item, true)' v-on="on") mdi-eye
          | Visualizar
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon.mr-2(v-if='validarModificar()' color='warning' @click='editItem( item,false )' v-on="on") mdi-pencil
          | Editar
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon(v-if='validarEliminar()' color='error' @click='deleteItem(item)' v-on="on") mdi-delete
          | Eliminar
      template(v-slot:no-data)
        h1 No hay datos de proveedores
</template>

<script>
import Api from '@/services/methods'
import ProveedorM from '@/components/modals/ProveedorM'
export default {
  data: () => ({
    dialog: false,
    read: false,
    mostrar: true,
    oth: false,
    edicion: false,
    loading: true,
    headers: [
      { text: 'Rif', align: 'left', value: 'rif' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Telefono', value: 'telefono' },
      { text: 'Correo', value: 'email' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    search: '',
    permisosRuta: {},
    proveedores: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),

  components: {
    ProveedorM
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarProveedor()
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta === 'Proveedor'
      )
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },

    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },

    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },

    listarProveedor () {
      Api.get('/proveedor/prove')
        .then(response => {
          this.proveedores = response.data
          console.log('data')
          console.log(this.proveedores)
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    editItem (item, bool) {
      this.editedIndex = this.proveedores.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.edicion = true
      this.read = bool

      if (item.web === '' && bool === true) {
        this.mostrar = false
      } else if (item.web !== '' && bool === true) {
        this.mostrar = true
      }

      if (bool === false) {
        this.mostrar = true
      }
      this.dialog = true
      this.oth = true
    },

    deleteItem (item) {
      const index = this.proveedores.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.proveedores.splice(index, 1)
          Api.delete('/proveedor/' + item._id).then(response => {
          // Api.put('/proveedor/deletelog/' + item._id).then(response => {
          //   console.log(response)
          })
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.read = false
        this.edicion = false
        this.editedIndex = -1
      }, 300)
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      this.ot = false
      this.listarProveedor()
    }
  }
}
</script>
